// CookieYes consent-management loader. Injected only when
// VITE_COOKIEYES_SITE_ID is set (prod) — mirrors the env-gated `sentry.ts`
// pattern, so dev/staging stay banner-free here. CookieYes renders the
// cookie-consent banner and gates trackers; the homegrown ConsentBanner was
// removed in favor of it (CookieYes is the system of record).
//
// `connect.leanin.org` shares the `leanin.org` CookieYes site (same client
// id). For shared consent across the property, register the subdomain and
// scope the consent cookie to `.leanin.org` in the CookieYes dashboard.

const siteId = import.meta.env.VITE_COOKIEYES_SITE_ID;

if (
  typeof document !== 'undefined' &&
  typeof siteId === 'string' &&
  siteId.length > 0
) {
  const script = document.createElement('script');
  script.id = 'cookieyes';
  script.type = 'text/javascript';
  script.src = `https://cdn-cookieyes.com/client_data/${siteId}/script.js`;
  // Prepend so CookieYes loads as early as the SPA allows and can block
  // trackers before they run.
  document.head.prepend(script);
}
